module.exports = __webpack_public_path__ + "static/media/PFC.724bc30b.txt";